import { useLanguage } from '../contexts/LanguageContext';
import { Globe } from 'lucide-react';

function LanguageSelector({ className = '' }) {
  const { language, setLanguage } = useLanguage();

  return (
    <div className={`flex items-center gap-1.5 ${className}`} data-testid="language-selector">
      <Globe className="w-4 h-4 text-gray-400" />
      <button
        onClick={() => setLanguage('fr')}
        data-testid="lang-fr-btn"
        className={`px-2 py-1 rounded text-sm font-medium transition ${
          language === 'fr'
            ? 'bg-orange-500 text-white'
            : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
        }`}
      >
        FR
      </button>
      <button
        onClick={() => setLanguage('en')}
        data-testid="lang-en-btn"
        className={`px-2 py-1 rounded text-sm font-medium transition ${
          language === 'en'
            ? 'bg-orange-500 text-white'
            : 'bg-gray-700 text-gray-300 hover:bg-gray-600'
        }`}
      >
        EN
      </button>
    </div>
  );
}

export default LanguageSelector;
